import { render, staticRenderFns } from "./AssuranceRequirementSuggestionSelector.vue?vue&type=template&id=11e53ee8"
import script from "./AssuranceRequirementSuggestionSelector.vue?vue&type=script&lang=js"
export * from "./AssuranceRequirementSuggestionSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports